<template>
    <div class="exploreTeam">
        <img class="exploreTeam-back" :src="bkimg" alt="">
        <div class="exploreTeam-content">
            <div class="exploreTeam-content-item">
                <div class="exploreTeam-content-title">
                    <div class="fl">
                        <div style="font-weight:bold;margin-bottom:5px;font-size:26px;">{{guests.typename}}</div>
                        <div style="font-size:14px;color:#7e8891;">{{guests.description}}</div>
                    </div>
                    <div class="fr page">
                       <img src="../static/images/turnleft.png" alt="">
                      <img src="../static/images/turnright.png" alt="">
                    </div>
                </div>
                <div class="exploreTeam-content-main">
                    <div class="exploreTeam-content-main-left">
                        <p style="color:#0080cc;margin-bottom:38px;">{{guests.typename}} ————</p>
                        <p style="margin-bottom:38px;">{{explormember.typename}} -</p>
                        <p>{{trips.typename}} -</p>
                    </div>
                    <div class="exploreTeam-content-main-right">
                        <div class="main-right-item" v-for='(guest,index) in guests.jzmLeaders' :key='index' @click='allpersonitem(index)'>
                            <img  class="main-right-item-img" :src="guest.img" alt="">
                            <div class="main-right-item-word">
                                <div style="font-weight:bold;font-size:20px;margin-bottom:5px;">{{guest.lname}}</div>
                                <div style="font-size:14px;">{{guest.positions}}</div>
                                <div class="main-right-item-word-introduce" style="font-size:14px;color:#828282;" >{{guest.detail}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="exploreTeam-content-item">
                <div class="exploreTeam-content-title">
                    <div class="fl">
                        <div style="font-weight:bold;margin-bottom:5px;font-size:26px;">{{explormember.typename}}</div>
                        <div style="font-size:14px;color:#7e8891;">{{explormember.description}}</div>
                    </div>
                    <div class="fr page">
                       <img src="../static/images/turnleft.png" alt="">
                      <img src="../static/images/turnright.png" alt="">
                    </div>
                </div>
                <div class="exploreTeam-content-main">
                    <div class="exploreTeam-content-main-left">
                        <p style="margin-bottom:38px;">{{guests.typename}} -</p>
                        <p style="margin-bottom:38px;color:#0080cc;">{{explormember.typename}} ————</p>
                        <p>{{trips.typename}} -</p>
                    </div>
                    <div class="exploreTeam-content-main-right">
                        <div class="main-right-item" v-for='(guest,index) in explormember.jzmLeaders' :key='index'>
                            <img  class="main-right-item-img" :src="guest.img" alt="">
                            <div class="main-right-item-word">
                                <div style="font-weight:bold;font-size:20px;margin-bottom:5px;">{{guest.lname}} </div>
                                <div style="font-size:14px;">{{guest.positions}}</div>
                                <div class="main-right-item-word-introduce" style="font-size:14px;color:#828282;">{{guest.detail}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="exploreTeam-content-item" >
                <div class="exploreTeam-content-title">
                    <div class="fl">
                        <div style="font-weight:bold;margin-bottom:5px;font-size:26px;">{{trips.typename}}</div>
                        <div style="font-size:14px;color:#7e8891;">{{trips.description}}</div>
                    </div>
                    <div class="fr page">
                       <img src="../static/images/turnleft.png" alt="">
                      <img src="../static/images/turnright.png" alt="">
                    </div>
                </div>
                <div class="exploreTeam-content-main">
                    <div class="exploreTeam-content-main-left">
                        <p style="margin-bottom:38px;">{{guests.typename}} -</p>
                        <p style="margin-bottom:38px;">{{explormember.typename}} -</p>
                        <p style="margin-bottom:38px;color:#0080cc;">{{trips.typename}} ————</p>
                    </div>
                    <div class="exploreTeam-content-main-right">
                        <div class="main-right-item" v-for='(guest,index) in trips.jzmLeaders' :key='index'>
                            <img  class="main-right-item-img" :src="guest.img" alt="">
                            <div class="main-right-item-word">
                                <div style="font-weight:bold;font-size:20px;margin-bottom:5px;">{{guest.lname}} </div>
                                <div style="font-size:14px;">{{guest.positions}}</div>
                                <div class="main-right-item-word-introduce" style="font-size:14px;color:#828282;">{{guest.detail}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {leadertype} from '@/api/leader.js'
import bkimg from '@/assets/explore-back.png'
export default {
  data () {
    return {
      listquery: {
        sort: 'orderno',
        order: 'asc',
        typename: ''
      },
      guests: [],
      explormember: [],
      trips: [],
      bkimg: bkimg
    }
  },
  methods: {
    getleaderlist () {
      leadertype(this.listquery).then(res => {
        res.data.data.items[0].jzmLeaders.forEach(element => {
          element.down = false
        })
        this.guests = res.data.data.items[0]
        this.explormember = res.data.data.items[1]
        this.trips = res.data.data.items[2]
      })
    },
    allpersonitem (index) {
      this.guests.jzmLeaders[index].down = !this.guests.jzmLeaders[index].down
      //   this.$set(this.guests.jzmLeaders[index], 'down', !this.guests.jzmLeaders[index].down)
      console.log(this.guests.jzmLeaders)
    }
  },
  created () {
    this.getleaderlist()
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
  }
}
</script>

<style scoped>
.exploreTeam{
    width:100%;
    height:100%;
    background:#eee;
    position: relative;
    padding-bottom:40px;
}
.exploreTeam-back{
    width:100%;
    height:670px;
}
.exploreTeam-content{
    width:1280px;
    margin:0 auto;
    background:#fff;
    /* transform:translateY(-200px); */
    margin-top:-200px;
    padding:25px 25px;
    box-sizing: border-box;
    position: relative;
    z-index: 99;
}
.exploreTeam-content-item{
    margin-bottom:20px;
}
.fl{
    float:left;
}
.fr{
    float:right;
    display: none;
}
.fr img{
    width:29px;
    height:27px;
}
.fr img:nth-last-child(1){
    margin-left:-3px;
}
.exploreTeam-content-title{
    height:80px;
}
.exploreTeam-content-main{
    display:flex;

}
.exploreTeam-content-main-left{
    flex:0 0 300px;
    font-style:oblique;
    font-size:12px;
    padding-top:65px;
}
.exploreTeam-content-main-right{
    display: flex;
    flex-wrap:wrap;
}
.main-right-item{
    width:18.125rem;
    margin-left:24px;
    margin-bottom:24px;
    border:1px solid #ddd;
    position:relative;
    padding-bottom:90px;
}
.main-right-item:nth-of-type(3n+1){
    margin-left:0;
}
.main-right-item-img{
    width:100%;
}
.main-right-item-word{
    width:100%;
    padding:20px;
    box-sizing: border-box;
    background:#fbfcfd;
    position: absolute;
    bottom:0;
    left:0;
}
.main-right-item-word-introduce:hover{
    cursor: pointer;
    margin-top:5px;
    text-overflow:inherit;
    overflow: visible;
    white-space: pre-line;
    transition: all 0.5s;
    max-height: 120px;
    overflow-y:auto;
}
.main-right-item-word-introduce{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    height: fit-content;
}

.exploreTeam-content-item{
    margin-top:60px
}
::-webkit-scrollbar {
    background-color: #fff;
    width: 5px;
    height: 10px;
    background-clip: padding-box;
}
::-webkit-scrollbar-thumb {
    background-color: lightgray;
    border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/exploreTeam.vue